const ADD_CARD_ID = 'addCard';

export { ADD_CARD_ID };
